import { jsx } from 'react/jsx-runtime';
import { MultiselectList } from '@promo-platform/multiselect-list';
import { RadioList } from '@promo-platform/radio-list';
import { useConditionsWatch } from '@promo-platform/utils';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

const SelectListField = ({ alias, id, label, description, tooltip, tooltipLabel, options, minNumberOfAnswersValidation, maxNumberOfAnswersValidation, conditions, }) => {
    const { unregister, watch } = useFormContext();
    const shouldRender = useConditionsWatch(watch, conditions);
    useEffect(() => {
        if (!shouldRender) {
            unregister(alias);
        }
    }, [shouldRender, unregister, alias]);
    if (!shouldRender)
        return null;
    if (maxNumberOfAnswersValidation && maxNumberOfAnswersValidation.value > 1) {
        return (jsx(MultiselectList, Object.assign({}, {
            alias,
            id,
            label,
            description,
            tooltip,
            tooltipLabel,
            options,
            minNumberOfAnswersValidation,
            maxNumberOfAnswersValidation,
        })));
    }
    return (jsx(RadioList, Object.assign({}, {
        alias,
        id,
        label,
        description,
        tooltip,
        tooltipLabel,
        options,
        minNumberOfAnswersValidation,
        maxNumberOfAnswersValidation,
    })));
};

export { SelectListField };
